import React from 'react';

const Alert = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
  const variants = {
    default: "bg-raised text-fg border-line",
    destructive: "bg-raised border-line text-off-strong dark:text-off",
    success: "bg-raised border-line text-good-strong dark:text-good",
    warning: "bg-raised border-line-strong text-fg-2",
  };

  return (
    <div
      ref={ref}
      role="alert"
      className={`relative w-full rounded-xl border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 ${variants[variant]} ${className || ''}`}
      {...props}
    />
  );
});

Alert.displayName = "Alert";

const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/heading-has-content -- Content is provided by component users
  <h5
    ref={ref}
    className={`mb-1 font-medium leading-none tracking-head ${className || ''}`}
    {...props}
  />
));

AlertTitle.displayName = "AlertTitle";

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={`text-sm [&_p]:leading-relaxed ${className || ''}`}
    {...props}
  />
));

AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription };
